import { connect } from 'react-redux';

import { FEED_DRAWER_MEMBERS } from 'types/smallDrawer';
import { DRAWER_ADD_MEMBERS } from 'types/drawer';
import { MODAL_DELETE_MEMBER } from 'types/modal';
import { closeSmallDrawer } from 'actions/smallDrawer';
import { openDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import  { actions, selectors } from '@amplement/backend-connector';

import { getUserByIdSelector } from 'selectors/search';
import { getCurrentUserIdSelector } from 'selectors/user';
import MembersDrawer from './index';

const mapStateToProps = (state, { _feed }) => {
    const _user = getCurrentUserIdSelector(state);
    const user = getUserByIdSelector(state, _user) || {};
    const feed = selectors.feeds.feedByIdSelector(state, _feed);
    const isAdmin = feed?._administrators?.includes(user?.id);

    return ({
        isMeFeedAdmin: isAdmin,
        _acceptedMembers: selectors.members.feedMembersAcceptedSelectors(state, _feed),
        _pendingMembers: selectors.members.feedMembersPendingSelectors(state, _feed),
        _administratorsMembers: feed?._administrators,
        _user
    });
};

const mapDispatchToProps = (dispatch, { _feed }) => ({
    onClose: () => dispatch(closeSmallDrawer(FEED_DRAWER_MEMBERS)),
    unlinkUser: _user => dispatch(openModal(MODAL_DELETE_MEMBER, { _user, _feed })),
    openInviteContactDrawer: () => dispatch(openDrawer(DRAWER_ADD_MEMBERS, { _feed })),
    requestFeedMember: () => dispatch(actions.members.getFeedMembers(_feed)),
    onChangeAdministrator: (type, _admin) => {
        const adminUpdate = {
            [type === 'add' ? '_administratorsToAdd' : '_administratorsToRemove']: [_admin]
        };
    
        dispatch(actions.feeds.requestPatchMulticastFeed(_feed, adminUpdate));
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(MembersDrawer);
